// analytics.js — Plausible event wrapper
// Script geladen via public/index.html (tagged-events variant)
//
// BELANGRIJK: Registreer custom properties in Plausible dashboard:
//   Settings → Custom Properties → voeg toe: stap, bron, winkel, relatie, budget, geslacht

export function track(eventNaam, props = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(eventNaam, { props });
    }
  } catch {
    // Stil falen — analytics mag nooit de app breken
  }
}

export const Events = {
  // Stap doorlopen — met context over het profiel
  STAP_VOLTOOID: (stap, extra = {}) =>
    track("Stap voltooid", { stap: `Stap ${stap}`, ...extra }),

  // Suggesties geladen — was het AI of fallback?
  SUGGESTIES_GELADEN: (bron) =>
    track("Suggesties geladen", { bron }),

  // Klik op een productlink
  PRODUCT_KLIK: (naam, winkel) =>
    track("Product klik", { winkel }),

  // Mail succesvol verzonden
  MAIL_VERZONDEN: (budget, relatie) =>
    track("Mail verzonden", { budget, relatie }),

  // Deellink flow
  DEELLINK_AANGEMAAKT:  () => track("Deellink aangemaakt"),
  WHATSAPP_GEDEELD:     () => track("WhatsApp gedeeld"),
  LINK_GEKOPIEERD:      () => track("Link gekopieerd"),

  // Begunstigde flow
  BEGUNSTIGDE_GEOPEND:  () => track("Begunstigde geopend"),
  BEGUNSTIGDE_VOLTOOID: () => track("Begunstigde voltooid"),

  // Viral loop gesloten
  VIRAL_CONVERSIE: () => track("Viral conversie"),
};
